import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import { RichText } from 'prismic-reactjs'
import LazyImage, { setPlaceholderImage } from '../LazyImage'

const SideImageWithText = ({ slice }) => {
  const doc = slice.primary
  const { width, height } = doc.image1.dimensions
  const maxWidth = 600
  return (
    <Root>
      <ImageWrapper>
        <LazyImage
          placeholder={setPlaceholderImage(width, height)}
          src={doc.image1.url}
          alt={doc.image1.alt}
          width={width}
        />
      </ImageWrapper>
      <TextWrapper>
        <RichText render={doc.content} />
      </TextWrapper>
    </Root>
  )
}

const Root = styled.div`
    ${tw`flex flex-col justify-center sm:flex-row mb-20`}
    min-height: calc(100vh - 230px);

    & h2 {
        ${tw`py-2`}
        font-size: 2rem;
        font-family: 'Futura Medium'
    }

    & p {
        font-size: 1rem;
    }
    
    & img {
        width: 100%;
        height: auto;
    }
`;

const TextWrapper = styled.article`
${tw`p-3 sm:p-6 sm:px-6 sm:w-1/2 flex flex-col justify-center`}
`;

const ImageWrapper = styled.div`
  flex-basis: 50%;
`;

export default SideImageWithText